
import { gql } from "@apollo/client";

const ADD_REMITTANCE = gql`
  mutation CreateManualRemittance($params: [CreateRemittanceInput!]!) {
    createManualRemittance(params: $params) {
      newlyInsertedRemittances {
        recordStatus
        statusDetail
        inputCheckNumber
        inputPurchaserId
        inputRemittanceKey
        databaseRemittanceId
        processedItems {
          recordStatus
          statusDetail
          inputItemKey
          inputInvoiceNumber
          databaseItemId
        }
      }
      processedAgainstExistingRemittances {
        recordStatus
        statusDetail
        inputCheckNumber
        inputPurchaserId
        inputRemittanceKey
        databaseRemittanceId
        processedItems {
          recordStatus
          statusDetail
          inputItemKey
          inputInvoiceNumber
          databaseItemId
        }
      }
      skippedRemittances {
        recordStatus
        statusDetail
        inputCheckNumber
        inputPurchaserId
        inputRemittanceKey
      }
    }
  }
`;

export default ADD_REMITTANCE;
